/** A gridline on a chart's left scale: the value it carries, and where it sits. */
export type ChartTick = {
  value: number;
  /** 0 at the baseline, 1 at the top of the plot. The caller maps it onto its own axis. */
  fraction: number;
};

const TICK_FRACTIONS = [0, 0.5, 1];

/**
 * Never zero at the top, or every tick would read 0 and sit on the baseline. Each line is
 * placed at the value it is labelled with rather than at its own fraction, so an odd maximum
 * cannot draw the middle line half a unit from its number. Keyed by value, which also
 * collapses the two lines a maximum of 1 rounds to the same number.
 */
export function toChartTicks(tallest: number): ChartTick[] {
  const top = Math.max(1, tallest);

  const byValue = new Map(
    TICK_FRACTIONS.map((fraction) => Math.round(top * fraction)).map((value) => [
      value,
      value / top,
    ])
  );

  return [...byValue].map(([value, fraction]) => ({ value, fraction }));
}
